export function getWeatherIcon(code: number | null): string {
  if (code === null) return '—';
  if (code === 0) return '☀️';
  if ([1, 2, 3].includes(code)) return '⛅';
  if ([45, 48].includes(code)) return '🌫️';
  if ([51, 53, 55, 61, 63, 65].includes(code)) return '🌧️';
  if ([71, 73, 75, 77].includes(code)) return '🌨️';
  if ([80, 81, 82].includes(code)) return '🌦️';
  if ([95, 96, 99].includes(code)) return '⛈️';
  return '🌡️';
}

export function getWeatherLabel(code: number | null): string {
  if (code === null) return '';
  if (code === 0) return 'Vedro';
  if ([1, 2].includes(code)) return 'Djelomično oblačno';
  if (code === 3) return 'Oblačno';
  if ([45, 48].includes(code)) return 'Magla';
  if ([51, 53, 55].includes(code)) return 'Rosulja';
  if ([61, 63, 65].includes(code)) return 'Kiša';
  if ([71, 73, 75, 77].includes(code)) return 'Snijeg';
  if ([80, 81, 82].includes(code)) return 'Pljuskovi';
  if ([95, 96, 99].includes(code)) return 'Grmljavina';
  return '';
}